module.exports = __webpack_public_path__ + "img/admin.913adab2.svg";